import { render, staticRenderFns } from "./HeroItem.vue?vue&type=template&id=7cbbe746"
import script from "./HeroItem.vue?vue&type=script&lang=js"
export * from "./HeroItem.vue?vue&type=script&lang=js"
import style0 from "./HeroItem.vue?vue&type=style&index=0&id=7cbbe746&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports